export default __webpack_public_path__ + "static/logo_circle_design-2dbefdfe5cc39c1715346a648ed65087.png";